//coded by Narain on (10/09/2024)

import { styled } from '@mui/system';
import { Box, IconButton } from '@mui/material';

// Main container styling
export const NavBarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(2, 3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1), // smaller padding on small screens
  },
}));

// Logo styling
export const Logo = styled('img')(({ theme }) => ({
  height: '40px',
  [theme.breakpoints.down('sm')]: {
    height: '30px', // smaller logo on small screens
  },
}));

// Regular buttons styling (New Chat, Profile, Close)
export const IconButtonStyled = styled(IconButton)(({ theme, button }) => ({
  marginLeft: '0.5em',
  backgroundColor: theme.palette.grey[200],
  color: theme.palette.black,
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: button === 'close'
      ? theme.palette.error.light
      : theme.palette.info.light,
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: '0.2em', // smaller margin on small screens
  },
}));

// Hamburger button styling for mobile
export const HamburgerButtonStyled = styled(IconButton)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('sm')]: {
    display: 'block',
    color: theme.palette.black,
    borderRadius: '20%',
  },
}));
